import { CardActions, useTheme } from "@mui/material"
import { StartButton, StepButton } from "components/Button"

export const DirectionCardActions = ({
  onStart = () => {},
  onStep = () => {},
}) => {
  const theme = useTheme()
  const { root, actionButton } =
    theme.components[`DirectionCardActions`]?.styleOverrides || {}

  return (
    <CardActions sx={root}>
      <StartButton sx={actionButton} onClick={onStart} />
      <StepButton sx={actionButton} onClick={onStep} />
    </CardActions>
  )
}
